import React, { FC } from 'react'
import { StatusProps } from './Status-types'
import { statusStyles } from './Status-styles'
import { cn } from 'ethcss'
import { colors } from '../../theme'
import translate from '../../core/translate'
import { Tooltip } from '../../atoms/Tooltip'

const Status: FC<StatusProps> = ({ status, children, disable, className, isList }) => {
    return (
        <div
            className={cn(
                className,
                statusStyles.status,
                { [statusStyles.disable]: disable },
                isList ? statusStyles.statusList : ''
            )}
            style={{ borderColor: colors[status ? status : 'offline'] }}
        >
            <div className={statusStyles.main}>
                <Tooltip isEnabled={true} title={translate(status || '')} position="right">
                    <div className={statusStyles.statusText}>{children}</div>
                </Tooltip>
            </div>
        </div>
    )
}

export { Status }
